import { getFullUrl } from 'hubspot-url-utils';
function getJsFormsUrl() {
  return getFullUrl('js', {
    domainOverride: 'hsforms',
    tldOverride: 'net'
  });
}
export default getJsFormsUrl;